import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService, AppService, LocalStorageService, PopDataService } from '../../../service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { now } from 'moment';
import { ModalController, NavParams, NavController, PickerController } from '@ionic/angular';
import { PickerOptions } from "@ionic/core";
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
import { NewPageSelectComponent } from '../new-page-select/new-page-select.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-inspection-object',
  templateUrl: './add-inspection-object.component.html',
  styleUrls: ['./add-inspection-object.component.scss'],
})
export class AddInspectionObjectComponent implements OnInit {
  staffList = [];
  orgList = [];
  selectedOrg;
  isInvestigation: boolean;
  org;
  insuranceList = [];  // 保险情况下拉code
  editable = false;
  attachIds = '';
  objects = [];
  originalObjects;

  constructor(
    public dataService: DataService,
    public appService: AppService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalController: ModalController,
    public pickerController: PickerController,
    public localStorageService: LocalStorageService,
    public popDataService: PopDataService,
    private translateService: TranslateService,
    ) {
    let params = this.navParams.data;
    this.objects = JSON.parse(JSON.stringify(params.currentData)) ? JSON.parse(JSON.stringify(params.currentData)) : [];
    this.editable = params.editable ? params.editable : false;
    const a = this.popDataService.editable;
    if (a || params.editable) {
      this.editable = true;
    }
  }

  // ionViewDidEnter() {
  //   this.ngOnInit();
  // }

  ngOnInit() {
    // 设置标题
    document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.add_inspection_object.inspection_obj_add');
    if (dd.env.platform !== 'notInDingTalk') {
      dd.biz.navigation.setTitle({
        title: this.translateService.instant('shared_components.add_inspection_object.inspection_obj_add') // 钉钉设置导航栏标题
      });
    }

    if (this.objects.length === 0 && !this.objects[0]) {
      this.objects[0] = {displayObjectName: null};
    }

    const that = this;
    window.onpopstate = function () {
      const a = document.getElementsByTagName('app-add-inspection-object');
      if (a.length > 0) {
        setTimeout(() => {
          that.modalController.dismiss();
          // window.history.forward();
        }, 100)
      }
    };
  }

  async cancel() {
    await this.modalController.dismiss();
    history.back();
  }

  async save() {
    if (!this.objects || this.objects.length === 0) { // 没有检查对象
      this.appService.toastTip(this.translateService.instant('shared_components.add_inspection_object.add_must'), true);
      return;
    }
    const data = this.objects.filter(res => res.displayObjectName && res.displayObjectName.length >0);
    data.forEach((res, index) => {
      res.id = res.id ? res.id : null;
      res.objectType = '_SYS_AA_Z';
      res.sequence = index;
    })
    await this.modalController.dismiss(data);
    history.back();
  }

  addObject() {
    this.objects.push({displayObjectName: null});
  }
  
  translateCode(code, translationList: any[]) {
    let lang = this.localStorageService.getStore("APP_LANG");
    let data = null;
    for (const item of translationList) {
      if (code === item.code) {
        switch (lang) {
          case 'zh_CN':
            data = item.code_desc_zh;
            break;
          case 'zh_TW':
            data = item.code_desc_tr;
            break;
          case 'en_US':
            data = item.code_desc_en;
            break;
          case 'vi':
            data = item.code_desc_vi;
            break;
          case 'km':
            data = item.code_desc_km;
            break;
          case 'th':
            data = item.code_desc_th;
            break;
          case 'lo':
            data = item.code_desc_lo;
            break;
        }
        return data ? data : item.code_desc_zh;
      }
    }
    return '';
  }

  translateCodes(code, translationList: any[]) {
    if (code && translationList) {
      let displayText = '';
      code.forEach(item => {
        translationList.forEach(element => {
          if (item === element.code) {
            let lang = localStorage.getItem("APP_LANG");
            let displayField = 'code_desc_zh';
            switch (lang) {
              case 'en_US':
                displayField = 'code_desc_en';
                break;
              case 'zh_TW':
                displayField = 'code_desc_tr';
                break;
              case 'vi':
                displayField = 'code_desc_vi';
                break;
              case 'km':
                displayField = 'code_desc_km';
                break;
              case 'th':
                displayField = 'code_desc_th';
                break;
              case 'lo':
                displayField = 'code_desc_lo';
                break;
              default:
                displayField = 'code_desc_zh';
                break;
            }
            displayText += (element[displayField] + ',');
          }
        });
      });
      displayText = displayText.substr(0, displayText.length - 1);
      return displayText;
    }
  }

  calculateEmployeeAge(birthDate: Date) {
    return (new Date().getFullYear() - birthDate.getFullYear() + 1);
  }

  deleteObject(index, item) {
    this.objects.splice(index, 1);
  }
}
